import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { bolita_verde, sub2_act1_Neto01, sub2_act1_Neto02, sub2_act1_Rolo_sorpredido, sub2_act2_CorteX } from '../../../assets/tema7';
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	questionGame: 3,
	win: 4,
	fail: 5,
	dialogTwo: 6,
	dialogThree: 7,
	dialogFour: 8,
	dialogFive: 9,
};

const stepThree = {
	cash_register: {
		ui: steps.questionGame,
		action: () => {

		}
	},
}

let blockButton = false
export const Theme7SubtopicTwoActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema7.activities.subtema2], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad2.sub2a2a01)
	})

	ObserverEmitter.on(EVENTS.tema7.topic2.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	const [selectResponse, setSelectResponse] = useState(-1)

	const selectResponseQuestion = (value) => {
		if (blockButton) {
			return
		}

		setSelectResponse(value)
		blockButton = true

		setTimeout(() => {
			if (value === 1) {
				setUiToShow(steps.win);
			} else {
				setUiToShow(steps.fail);
			}
		}, 1000);
	}

	const finishActivity = (value = 0) => {
		dispatch(
			completeOneTask({
				idActivity: 2,
				pointsWin: value,
				subtema: tasksId.tema7.activities.subtema2
			})
		);
		setUiToShow(steps.dialogTwo);
		ObserverEmitter.emit(EVENTS.tema7.topic2.actScene, "move_client_1");
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad2.sub2a2n02)
	}

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 2);
						blockButton = false
						setSelectResponse(-1)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Cuenta el efectivo.' />
					<DialogBarNew
						dialog={`¡Vamos allá! Utiliza tu ticket de Corte X para contar el efectivo que hay en tu caja. Ambos deben coincidir si se entregó el cambio correcto al cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Control de efectivo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.tema7.topic2.actScene, "cash_register");
							setUiToShow(-1);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.questionGame && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<div className='h-full w-[304px] md:w-[400px] gradiantBlueClient fixed z-30 right-0'>
						<div className='h-[64px] md:h-[80px] w-full px-6 flex justify-center items-center'>
							<div className='h-[24px] md:h-[40px] w-full bg-red_primary rounded-[8px] border-[1px] border-[#FD9591] flex justify-center items-center'>
								<span className='text-white text-[10px] md:text-[16px]'>¿Es correcta la cantidad?</span>
							</div>
						</div>
						<div className='h-[calc(100%-64px)] md:h-[calc(100%-80px)] w-full relative md:py-[48px]'>
							<div className='absolute z-20 w-full h-[100px] bottom-0 px-6'>
								<div onClick={() => {
									selectResponseQuestion(1)
								}} className={`w-full h-[40px] rounded-[12px] flex ${selectResponse === 1 ? "bg-yellow_primary" : "bg-gray_text_block"}`}>
									<div className='h-full w-[20%] flex justify-center items-center'>
										<span className='font-semibold text-[14px] text-[#E3211B]'>a)</span>
									</div>
									<div className='h-full w-[80%] flex items-center pl-[30%]'>
										<span className='font-semibold text-[16px]'>Si</span>
									</div>
								</div>

								<div onClick={() => {
									selectResponseQuestion(0)
								}} className={`w-full h-[40px] rounded-[12px] flex ${selectResponse === 0 ? "bg-yellow_primary" : "bg-gray_text_block"} mt-2`}>
									<div className='h-full w-[20%] flex justify-center items-center'>
										<span className='font-semibold text-[14px] text-[#E3211B]'>a)</span>
									</div>
									<div className='h-full w-[80%] flex items-center pl-[30%]'>
										<span className='font-semibold text-[16px]'>No</span>
									</div>
								</div>
							</div>
							<div className='h-full w-full overflow-y-scroll hidden-scrooll relative'>
								<div className={`absolute z-10 ${[1, -1].includes(selectResponse) && "hidden"} h-[40px] w-full top-[170px] md:top-[190px] md:right-6 flex items-center justify-end`}>
									<div className='h-[30px] w-[30px]' >
										<img className='h-full w-full' src={bolita_verde} alt="bolita verde" />
									</div>
								</div>
								<img className='h-[450px] md:h-[500px] w-full' src={sub2_act2_CorteX} alt="cortex" />
							</div>
						</div>
					</div>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Has utilizado tu ticket de Corte X de manera adecuada."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							finishActivity(10)
						}}
					/>
				</>
			)}

			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="¡No pierdas el ánimo! Recuerda utilizar tu ticket de Corte X de manera adecuada."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							finishActivity()
						}}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<ViewPerson img={sub2_act1_Neto01} />
					<DialogBarNew
						name='Neto'
						dialog={`Hizo un pago con un billete de $50 pesos, por eso se le entrego la feria de $16 pesos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad2.sub2a2r03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={sub2_act1_Rolo_sorpredido} />
					<DialogBarNew
						name='Rolo'
						dialog={`Entonces me confundí. Pensé que había pagado con un billete de $100 pesos. Gracias por aclarar el malentendido.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad2.sub2a2n04)
							ObserverEmitter.emit(EVENTS.tema7.topic2.actScene)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={sub2_act1_Neto02} />
					<DialogBarNew
						name='Neto'
						dialog={`Estamos para servirle.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							navigator("/home7/tema7/subtema2/activityThree");
						}}
					></DialogBarNew>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}